<template>
    <div v-cloak>
        <div v-if="enrolmentDetails && enrolmentDetails[signatureType]">
            <span
                v-html="enrolmentDetails ? enrolmentDetails[signatureType] : ''"
            />
        </div>
        <div v-show="!(enrolmentDetails && enrolmentDetails[signatureType])">
            <b-btn
                v-b-tooltip.hover
                title="Employer Signature"
                variant="primary"
                :disabled="disabled"
                @click="showModal"
            >
                Employer
            </b-btn>

            <b-modal
                ref="levelSignatureModal"
                v-b-modal.modal-center
                :class="'text-left'"
                size="lg"
                :title="'Level '+level +' - '+ description"
                no-close-on-backdrop
                no-close-on-esc
                ok-title="Save"
                cancel-variant="danger"
                @ok="onSubmit"
                @cancel="hideModal"
            >
                <b-form
                    @submit="onSubmit"
                >
                    <b-form-group
                        label="Employer Name"
                        label-for="employerName"
                    >
                        <b-form-input
                            id="employerName"
                            ref="employerName"
                            v-model="employerName"
                            type="text"
                            placeholder="Employer Name"
                            required
                        />

                        <signature-pad-component
                            v-model="signature"
                            :signature-type="signatureType"
                        />
                    </b-form-group>

                    <div v-if="bulkUpdate">
                        <level-selector
                            ref="currentValue"
                            :pre-selected-level="'Level '+level"
                            :disable="disabledLevels"
                            @bulk-levels="setLevels"
                        />
                    </div>
                </b-form>
            </b-modal>
        </div>
    </div>
</template>

<script>
/* global Noty */
/* global axios */
import LevelSelector from './LevelSelector.vue';
import SignaturePadComponent from '../../SignaturePadComponent.vue';

export default {
    name: 'LevelSignatureComponent',
    components: {
        LevelSelector,
        SignaturePadComponent,
    },
    mixins: [],
    props: {
        student: {
            type: Object,
            required: true,
        },
        enrolmentDetails: {
            type: Object,
            required: false,
            default: () => {},
        },
        signatureType: {
            type: String,
            required: true,
        },
        signatureName: {
            type: String,
            required: true,
        },
        signatureDate: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        bulkUpdate: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            actualSelectedLevels: [],
            signature: '',
            employerName: '',
            error: false,
            signedLevels: [],
        };
    },
    computed: {
        level() {
            return Number(this.$route.path.split('/')[3].slice(-1));
        },
        disabledLevels() {
            return this.signedLevels.concat([this.level.toString()]);
        },
    },
    watch: {},
    mounted() {
        this.getSignaturesAlreadySigned();
    },
    created() {},
    methods: {
        clearForm() {
            this.signature = '';
            this.employerName = '';
        },
        setLevels(levels) {
            this.actualSelectedLevels = levels;
        },
        showModal() {
            this.clearForm();
            this.$refs.employerName.focus();
            this.$refs.levelSignatureModal.show();
        },
        hideModal() {
            this.$refs.levelSignatureModal.hide();
        },
        onSubmit(event) {
            event.preventDefault();
            if (((this.bulkUpdate && this.actualSelectedLevels.length > 0) || (!this.bulkUpdate)) && this.employerName && this.signature !== '') {
                this.isLoading = true;
                this.$refs.levelSignatureModal.hide();
                axios
                    .patch(`/api/signatureBulkUpdate/${this.student.id}`, {
                        signatureType: this.signatureType,
                        signatureName: this.signatureName,
                        signatureDate: this.signatureDate,
                        employerName: this.employerName,
                        signature: this.signature,
                        levels: this.bulkUpdate ? this.actualSelectedLevels : [this.level],
                    })
                    .then(() => {
                        this.$emit('refreshData');
                        this.isLoading = false;
                        if (this.bulkUpdate) {
                            this.actualSelectedLevels.forEach((el) => {
                                this.signedLevels.push(el.toString());
                            });
                        } else {
                            this.signedLevels.push(this.level);
                        }

                        const n = new Noty({
                            text: 'Siganture Saved',
                            type: 'success',
                            modal: false,
                        });
                        n.show();

                        // clear the canvas
                        this.signature = '';
                    })
                    .catch((error) => {
                        new Noty({
                            text: error.response.data.message,
                            type: 'error',
                            timeout: 1000,
                        }).show();
                    });
            }
        },
        getSignaturesAlreadySigned() {
            axios
                .get('/api/enrolmentDetail', {
                    params: {
                        banner_id: this.student.banner_id,
                        course_id: this.student.course_id,
                        // level: this.level,
                    },
                })
                .then((response) => {
                    //  remove blank teachers
                    response.data.data.forEach((el) => {
                        if (el[this.signatureName] !== null) {
                            this.signedLevels.push(el.level);
                        }
                    });
                })
                .catch((error) => {
                    const n = new Noty({
                        text: error.response.data.message,
                        type: 'error',
                    });
                    n.show();
                });
        },
    },
    validations: {},
};
</script>
